<template>
  <div class="ColorButtons">
    <ColorPickerButton
      :title="$t('ColorButtons.TextColor')"
      icon="mdi:format-color-text"
      v-model="textColor"
    />

    <ColorPickerButton
      :title="$t('ColorButtons.BackgroundColor')"
      icon="mdi:format-color-fill"
      v-model="backgroundColor"
    />
  </div>
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import ColorPickerButton from './ColorPickerButton.vue';

export default {
  components: {
    ColorPickerButton,
  },
  mixins: [useI18n],

  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  computed: {
    textColor: {
      get() {
        return this.editor.getAttributes('textStyle').color;
      },

      set(newColor) {
        if (!newColor) {
          this.editor.commands.unsetColor();
          return;
        }

        this.editor.chain().focus().setColor(newColor).run();
      },
    },

    backgroundColor: {
      get() {
        return this.editor.getAttributes('highlight').color;
      },

      set(newColor) {
        if (!newColor) {
          this.editor.commands.unsetHighlight();
          return;
        }

        this.editor.chain().focus().toggleHighlight({ color: newColor }).run();
      },
    },
  },

  i18n: {
    en: {
      'ColorButtons.TextColor': 'Text color',
      'ColorButtons.BackgroundColor': 'Background color',
    },
    es: {
      'ColorButtons.TextColor': 'Color del texto',
      'ColorButtons.BackgroundColor': 'Color de fondo',
    },
    de: {
      'ColorButtons.TextColor': 'Textfarbe',
      'ColorButtons.BackgroundColor': 'Hintergrundfarbe',
    },
    fr: {
      'ColorButtons.TextColor': 'Couleur du texte',
      'ColorButtons.BackgroundColor': 'Couleur de fond',
    },
    it: {
      'ColorButtons.TextColor': 'Colore del testo',
      'ColorButtons.BackgroundColor': 'Colore di sfondo',
    },
    pt: {
      'ColorButtons.TextColor': 'Cor do texto',
      'ColorButtons.BackgroundColor': 'Cor de fundo',
    },
  },
};
</script>

<style lang="scss">
.ColorButtons {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
</style>